import { z } from 'zod';
import { numericString, optionalNumericString } from './common.schema.js';
export const createLeadSchema = z.object({
    phone_number: z.string().regex(/^\d{10,15}$/, 'Invalid phone number'),
    list_id: z.number(),
    status: z.string().default('new'),
    data: z.record(z.unknown()).nullable().optional(),
});
export const updateLeadSchema = z.object({
    status: z.string().optional(),
    data: z.record(z.unknown()).nullable().optional(),
});
export const upsertLeadSchema = z.object({
    id: z.number().optional(),
    phone_number: z.string().regex(/^\d{10,15}$/, 'Invalid phone number'),
    list_id: z.number(),
    status: z.string().default('new'),
    data: z.record(z.unknown()).nullable().optional(),
});
export const batchUpdateLeadsSchema = z.object({
    list_id: z.number(),
    changes: z.array(z.object({
        id: z.number(),
        status: z.string().optional(),
        data: z.record(z.unknown()).optional(),
    })),
});
export const listLeadsSchema = z.object({
    list_id: numericString,
    disposition: z.string().optional(),
    order_by: z.string().optional(),
    order_type: z.enum(['asc', 'desc']).optional().default('desc'),
    page: optionalNumericString(0),
    page_size: optionalNumericString(50).refine((v) => v > 0 && v <= 1000, 'Page size must be 1-1000'),
});
